var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"spanTitle"},[_vm._v(_vm._s(_vm.params.title))]),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"light","content":_vm.params.tooltip,"placement":"top","popper-class":"myTooltipPopper"}},[_c('i',{staticClass:"el-icon-warning-outline"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }